import { Flex } from '@chakra-ui/react';
import ProductionItineraryForm from 'components/forms/capacity/productionItinerary/ProductionItineraryForm';
import { SidebarHelpContext } from 'contexts/SidebarHelpContext';
import { ISidebarHelp } from 'models/sidebarHelp/sidebarHelp.model';
import { useContext, useEffect } from 'react';
import { URL_CT360, URL_FALE_CONOSCO } from 'utils/consts/global';

export default function CadastroRoteiros() {
	const { setters } = useContext(SidebarHelpContext);

	const { setDataSidebar } = setters;

	const helpTipologiaParadas: ISidebarHelp = {
		title: 'Roteiros',
		firstParagraph:
			'Nesta tela é possível cadastrar e visualizar roteiros de produção. O roteiro de produção do produto apresenta todas as operações necessárias para fabricação de um produto, os grupos de recurso planejados, seus recursos habilitados, as atividades e os tempos planejados de setup e processamento.',
		secondParagraph:
			'Para cadastrar um roteiro selecione o Produto, e clique em “Incluir Atividades” para adicionar as atividades que compõem o roteiro de produção do produto. Acesse “Cadastrar Atividades” para adicionar atividades. Uma vez listada as atividades, informe a quantidade de itens produzidos, o tempo de máquina e o tempo do colaborador operando a máquina naquela atividade. Observação: para atividades manuais, deixe o campo de tempo de máquina zerado.',
		thirdParagraph:
			'Caso for necessário criar um roteiro de produção para um novo produto que será muito similar a um roteiro de produção de outro produto já criado na easy360. Nesse caso, ao invés de criar todo o roteiro de produção do início, pode ser mais interessante acessar o roteiro de produção de um produto similar e utilizar a funcionalidade "Reutilizar roteiro".',
		firstLink: URL_CT360,
		secondLink: URL_FALE_CONOSCO,
	};

	useEffect(() => {
		setDataSidebar(helpTipologiaParadas);
	}, []);

	return (
		<Flex
			direction='column'
			pt={{ sm: '125px', lg: '75px' }}
		>
			<ProductionItineraryForm />
		</Flex>
	);
}
